/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BulkTimeseriesRain } from "./BulkTimeseriesRain";
import {
  BulkTimeseriesRainFromJSON,
  BulkTimeseriesRainFromJSONTyped,
  BulkTimeseriesRainToJSON,
  BulkTimeseriesRainToJSONTyped,
} from "./BulkTimeseriesRain";

/**
 *
 * @export
 * @interface PaginatedBulkTimeseriesRainList
 */
export interface PaginatedBulkTimeseriesRainList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<BulkTimeseriesRain>;
}

/**
 * Check if a given object implements the PaginatedBulkTimeseriesRainList interface.
 */
export function instanceOfPaginatedBulkTimeseriesRainList(
  value: object
): value is PaginatedBulkTimeseriesRainList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedBulkTimeseriesRainListFromJSON(
  json: any
): PaginatedBulkTimeseriesRainList {
  return PaginatedBulkTimeseriesRainListFromJSONTyped(json, false);
}

export function PaginatedBulkTimeseriesRainListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedBulkTimeseriesRainList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(BulkTimeseriesRainFromJSON),
  };
}

export function PaginatedBulkTimeseriesRainListToJSON(json: any): PaginatedBulkTimeseriesRainList {
  return PaginatedBulkTimeseriesRainListToJSONTyped(json, false);
}

export function PaginatedBulkTimeseriesRainListToJSONTyped(
  value?: PaginatedBulkTimeseriesRainList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(BulkTimeseriesRainToJSON),
  };
}
